export default __webpack_public_path__ + "66025830e6e30579c870039158c00acd.svg";